module.exports = __webpack_public_path__ + "static/media/cc.b230472a.png";